import create, { GetState, Mutate, SetState, StoreApi } from "zustand";
import { persist, devtools } from "zustand/middleware";
import { Region } from "@util/types";

export interface State {
  currentRegion: Region;
  validRegions: Region[];
  setValidRegions: (regions: Region[]) => void;
  setCurrentRegion: (currentRegion: Region) => void;
}

const defaultStates = {
  currentRegion: { iban: process.env.GATSBY_DEFAULT_IBAN_REGION || "nz" },
  validRegions: [],

}

const store = persist<
  State,
  SetState<State>,
  GetState<State>,
  Mutate<StoreApi<State>, [["zustand/persist", Partial<State>]]>
>(
  (set, get) => ({
    ...defaultStates,
    setValidRegions: (regions: Region[]) => // to be deleted
      set(state => ({ ...state, validRegions: regions })),
    setCurrentRegion: (currentRegion: Region) => set(() => ({ currentRegion }))
  }),
  {
    name: "zuru-store", // unique name
    getStorage: () => localStorage,
  },
);

export const useStore = create(
  process.env.GATSBY_NODE_ENV !== "production" ? devtools(store) : store,
);
